import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { ExclamationMarkIcon } from "@/components/Icons/ExclamationMarkIcon";
import { usePhoneNumberActivationCode } from "@/hooks/usePhoneNumberActivationCode";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useState } from "react";

interface NumberInputPageProps {
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  onNextStep: () => void;
}

export const NumberInputPage = ({ phoneNumber, setPhoneNumber, onNextStep }: NumberInputPageProps) => {
  const [isValid, setIsValid] = useState(true);
  const [processing, setProcessing] = useState(false);
  const { trigger } = usePhoneNumberActivationCode();

  const formatPhoneNumber = (value: string): string => {
    if (value.length > 13) return phoneNumber;
    const numericValue = value.replace(/\D/g, "");
    if (numericValue.length > 11) return numericValue.slice(0, 11);
    if (numericValue.length <= 3) return numericValue;
    if (numericValue.length <= 7) return `${numericValue.slice(0, 3)}-${numericValue.slice(3, 7)}`;
    return `${numericValue.slice(0, 3)}-${numericValue.slice(3, 7)}-${numericValue.slice(7)}`;
  };

  const handleSubmit = () => {
    const number = formatPhoneNumber(phoneNumber);
    setPhoneNumber(number);
    setIsValid(isValidPhoneNumber(number, "JP"));
    setProcessing(true);
    trigger({ phoneNumber: number })
      .then(() => {
        onNextStep();
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const number = formatPhoneNumber(value);
    setPhoneNumber(number);
    setIsValid(isValidPhoneNumber(number, "JP"));
  };

  return (
    <>
      <h1 className="text-2xl mb-5 font-semibold text-center text-black">電話番号の登録</h1>
      <p className="text-center text-dark-gray">以下に電話番号を入力して送信すると、</p>
      <p className="text-center text-dark-gray">SMSに認証番号が送られます。</p>
      <div className="sm:w-[450px] mt-10 flex flex-col mx-auto justify-center">
        <input
          type="text"
          inputMode="numeric"
          value={phoneNumber}
          placeholder="電話番号を入力"
          className={`p-3 border rounded-lg focus:outline-none ${
            !isValid ? "border-red focus:border-red" : "border-input focus:border-primary"
          }`}
          onChange={handlePhoneNumberChange}
        />
        {!isValid && (
          <div className="flex items-center gap-1 mt-1">
            <ExclamationMarkIcon />
            <p className="text-red text-sm">有効な電話番号を入力してください</p>
          </div>
        )}
        <PrimaryButton
          className="mt-10"
          disabled={!phoneNumber || !isValid || processing}
          text="SMSを送信"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};
